import { graphql } from '@/gql';

export const UpdatePerformanceWeightResultMutation = graphql(`
    mutation UpdatePerformanceWeightResult($id: ObjectID!, $input: UpdateWeightResultInput!) {
        updateWeightResult(id: $id, input: $input) {
            ... on UpdateWeightResultSuccessfulResponse {
                result {
                    ...WeightPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    message
                    field
                }
            }
        }
    }
`);
